import NodeHelper from "../helpers/node_helper";
import NodeHandler from "../node_handler";

class DropdownSpoiler extends NodeHandler{
    __init_dom_schema(){
        return {
            wrapper: {
                selector: '.dropdown-spoiler__wrapper',
            }
        }
    }
    __init() {
        this.id = this.node.getAttribute('data-id')
        this.registerEvents('onToggled')
        this.addEventListener('onToggled', this.onToggled.bind(this))
    }
    onToggled(args){
        NodeHelper.ToggleClass(this.node, 'is--active', args?.is_active)
        this.resetSlideHeight()
    }
    resetSlideHeight(){
        const is_active = this.node.classList.contains('is--active')
        let height
        if(is_active){
            const rect = this.dom.wrapper.getBoundingClientRect()
            height = rect.height
        }else{
            height = 0
        }
        this.node.style.height = `${height}px`;
    }
}

export default DropdownSpoiler